import SEO from "../../data/seo";
import BreadCrumb from "../common/breadcrumb";
import HeaderTwo from "../../layout/headers/header-two";
import PortfolioFilter from "./portfolio-filter";
import FooterTwo from "../../layout/footers/footer-two";

const PortfolioFilterPage = () => {
    return (
        <>
            <SEO pageTitle="Gallery"/>
            <HeaderTwo/>
            <BreadCrumb title="Gallery" items={[
                { label: "Gallery" }
            ]}/>
            <PortfolioFilter/>
            <FooterTwo/>
        </>
    );
};

export default PortfolioFilterPage;